import axios from 'axios'

const CustomerMemoService = {
  async get (params = {}) {
    return axios.get('mkm/customer-memos', { params })
  },

  async exports (params = {}) {
    return axios.get('mkm/exports/customer-memos', { params })
  },

  async show (id) {
    return axios.get(`mkm/customer-memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('mkm/customer-memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`mkm/customer-memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`mkm/customer-memos/${data.id}`, { data })
  }
}

export default CustomerMemoService
